<app-legend [items]="legendItems" *ngIf="legendItems && legendItems.length"></app-legend>
